import dayjs from '../../helpers/dates';
import { NEEDS_DATES } from './constants';

interface DateRangeParams {
  operation?: string;
  timeMeasurement?: string;
  amount?: number;
}

const getDatesForDateRange = ({
  operation = 'add',
  timeMeasurement = 'month',
  amount = 1,
}: DateRangeParams = {}) => {
  const shifted = dayjs()[operation](amount, timeMeasurement);
  const start = shifted.startOf(timeMeasurement).format('YYYY-MM-DD');
  const end = shifted.endOf(timeMeasurement).format('YYYY-MM-DD');

  return { start, end };
};

const formatDateRange = (dateRange?: string) => {
  switch (dateRange) {
    case 'last_year':
      return getDatesForDateRange({
        operation: 'subtract',
        timeMeasurement: 'year',
      });
    case 'this_year':
      return getDatesForDateRange({
        timeMeasurement: 'year',
        amount: 0,
      });
    case 'last_month':
      return getDatesForDateRange({
        operation: 'subtract',
      });
    case 'this_month':
      return getDatesForDateRange({
        amount: 0,
      });
    case 'next_month':
      return getDatesForDateRange({});
    case 'next_quarter':
      return getDatesForDateRange({
        timeMeasurement: 'quarter',
      });
    case 'next_year':
      return getDatesForDateRange({
        timeMeasurement: 'year',
      });
    default:
      return getDatesForDateRange({
        timeMeasurement: 'quarter',
        amount: 0,
      });
  }
};

interface FormValues {
  report?: any;
  values?: any;
  startDate?: string;
  endDate?: string;
  orderBy?: any;
  sortDirection?: any;
}

const formValidation = ({
  report,
  values,
  startDate,
  endDate,
  orderBy,
  sortDirection,
}: FormValues) => {
  const errors: Record<string, string> = {};

  if (!report) {
    errors.report = 'Required';
  }
  if (!values || values.length < 1) {
    errors.values = 'Required';
  }
  if (!orderBy) {
    errors.orderBy = 'Required';
  }
  if (!sortDirection) {
    errors.sortDirection = 'Required';
  }
  if (NEEDS_DATES.includes(report?.value)) {
    if (!startDate) {
      errors.startDate = 'Required';
    }
    if (!endDate) {
      errors.endDate = 'Required';
    }
    if (dayjs(endDate).isSameOrBefore(startDate)) {
      errors.endDate = 'Must be after Start Date';
    }
  }
  return errors;
};

export { getDatesForDateRange, formatDateRange, formValidation };
